import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FTFRBusinesses from "../components/freezer-truck-for-rent/FTFRBusinesses";
import FTFRStandards from "../components/freezer-truck-for-rent/FTFRStandards";
import FTFRFailures from "../components/freezer-truck-for-rent/FTFRFailures";
import FTFRFleetSpec from "../components/freezer-truck-for-rent/FTFRFleetSpec";
import FTFRPricing from "../components/freezer-truck-for-rent/FTFRPricing";
import FTFRAreas from "../components/freezer-truck-for-rent/FTFRAreas";
import FTFRFaq from "../components/freezer-truck-for-rent/FTFRFaq";

import { freezerTruckForRentSections } from "../components/freezer-truck-for-rent/freezerTruckForRentSections";
import "../components/freezer-truck-for-rent/freezer-truck-for-rent.css";
import "../components/home/home.css";

const FreezerTruckForRent = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "ftfr-hero":
        return (
          <ContactHero
            key={index}
            variant="freezer-truck-for-rent"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "ftfr-businesses":
        return (
          <FTFRBusinesses
            key={index}
            title={section.title}
            businesses={section.businesses}
          />
        );

      case "ftfr-standards":
        return (
          <FTFRStandards
            key={index}
            title={section.title}
            description={section.description}
            standards={section.standards}
          />
        );

      case "ftfr-failures":
        return (
          <FTFRFailures
            key={index}
            title={section.title}
            description={section.description}
            failures={section.failures}
          />
        );

      case "ftfr-fleet-spec":
        return (
          <FTFRFleetSpec
            key={index}
            title={section.title}
            description={section.description}
            image={section.image}
            imageAlt={section.imageAlt}
            specRows={section.specRows}
          />
        );

      case "ftfr-pricing":
        return (
          <FTFRPricing
            key={index}
            title={section.title}
            descriptionMain={section.descriptionMain}
            rows={section.rows}
            descriptionNote={section.descriptionNote}
          />
        );

      case "ftfr-areas":
        return (
          <FTFRAreas
            key={index}
            title={section.title}
            areas={section.areas}
          />
        );

      case "ftfr-faq":
        return (
          <FTFRFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Freezer Truck for Rent in Dubai & Sharjah for Bulk Frozen Cargo</title>
        <meta
          name="description"
          content="Chiller Fleet Transport Offers freezer trucks for rent in Dubai & Sharjah for bulk frozen meat, seafood & frozen goods transport maintaining -18°C to -25°C. Hire today."
        />
        <link rel="canonical" href="https://chillerfleet.com/freezer-truck-for-rent" />
        <meta property="og:title" content="Freezer Truck for Rent in Dubai & Sharjah for Bulk Frozen Cargo" />
        <meta
          property="og:description"
          content="Chiller Fleet Transport Offers freezer trucks for rent in Dubai & Sharjah for bulk frozen meat, seafood & frozen goods transport maintaining -18°C to -25°C. Hire today."
        />
        <meta property="og:url" content="https://chillerfleet.com/freezer-truck-for-rent" />
        <meta name="twitter:title" content="Freezer Truck for Rent in Dubai & Sharjah for Bulk Frozen Cargo" />
        <meta
          name="twitter:description"
          content="Chiller Fleet Transport Offers freezer trucks for rent in Dubai & Sharjah for bulk frozen meat, seafood & frozen goods transport maintaining -18°C to -25°C. Hire today."
        />
      </Helmet>

      {freezerTruckForRentSections.map(renderSection)}
    </>
  );
};

export default FreezerTruckForRent;
